<div class="option-text">{{ JobSpecificationEntity.Name }} <fa-icon *ngIf="JobSpecificationEntity.UsedInCapacityCalculation" icon="question-circle" matTooltip="Werden für die Kappazitätsberechnung verwendet"></fa-icon></div>
<div class="edit-button">
    <button app-round-button matTooltip="Bearbeiten" matTooltipPosition="left" (click)="$event.stopPropagation(); EditJobSpecification(JobSpecificationEntity)">
        <fa-icon icon="pencil-alt"></fa-icon>
    </button>
</div>

